import { Beech } from './beech';

export default class BeechNotifications {
	private beech: Beech;
	private id: number;
	private prefix: string;
	private incomingCallNotificationVisible: boolean;

	public constructor(beech: Beech) {
		logg.log('notify >> init');
		this.beech = beech;
		this.id = Date.now();
		this.prefix = 'beech#' + this.id + ':';
		this.incomingCallNotificationVisible = false;
	}

	public register = () => {
		logg.log('notify >> register');

		this.beech.foreman.on('handle-notification-close', this.handleNotificationClose);

		this.beech.foreman.on('handle-notification-click', this.handleNotificationClick);

		this.beech.foreman.on('handle-notification-action', this.handleNotificationAction);
	};

	public showIncomingCallNotification = () => {
		logg.log('notify >> showIncomingCallNotification');

		if (!this.beech.persist.getNotifyIncomingCalls()) {
			// disabled
			return;
		}

		const data = this.beech.model.getData();
		const who = this.beech.model.getCallerLabel(data.callRemoteNumber, data.callRemoteUsers);
		const body = who ? `${who} is calling` : '';

		this.beech.foreman.send('show-notification', {
			tag: this.prefix + 'incoming_call',
			title: 'Incoming Call',
			body: body,
			icon: '/img/icons/ic_call_55acee_48dp_2x.png',
			requireInteraction: true,
			actions: [
				{
					action: 'accept',
					title: 'Accept',
					icon: '/img/icons/ic_check_black_24dp_1x.png'
				},
				{
					action: 'reject',
					title: 'Reject',
					icon: '/img/icons/ic_close_black_24dp_1x.png'
				}
			]
		});

		this.incomingCallNotificationVisible = true;
	};

	public refreshIncomingCallNotification = () => {
		if (this.incomingCallNotificationVisible) {
			this.showIncomingCallNotification();
		}
	};

	public hideIncomingCallNotification = () => {
		logg.log('notify >> hideIncomingCallNotification');

		this.incomingCallNotificationVisible = false;

		this.beech.foreman.send('close-notification-by-tag', {
			tag: this.prefix + 'incoming_call'
		});
	};

	public showQualityWarningNotification = (warningName: string) => {
		logg.log('notify >> showQualityWarningNotification');

		if (!this.beech.persist.getNotifyQualityWarnings()) {
			// disabled
			return;
		}

		this.beech.foreman.send('show-notification', {
			tag: this.prefix + 'warning-' + warningName,
			title: 'Quality Warning',
			body: warningName,
			icon: '/img/icons/ic_warning_black_48dp_2x.png',
			requireInteraction: true,
			actions: []
		});
	};

	public hideQualityWarningNotification = (warningName: string) => {
		this.beech.foreman.send('close-notification-by-tag', {
			tag: this.prefix + 'warning-' + warningName
		});
	};

	public showLowAvailableAgentsNotification = (numAgents: number) => {
		logg.log('notify >> showLowAvailableAgentsNotification');

		if (!this.beech.persist.getNotifyLowAgents()) {
			// disabled
			return;
		}

		this.beech.foreman.send('show-notification', {
			tag: this.prefix + 'low-available-agents',
			title: 'Low Available Agents',
			body: `There are currently ${numAgents} or fewer agents in Available`,
			icon: '',
			requireInteraction: true,
			actions: []
		});
	};

	public showLowOverflowAgentsNotification = (numAgents: number) => {
		logg.log('notify >> showLowOverflowAgentsNotification');

		if (!this.beech.persist.getNotifyLowAgents()) {
			// disabled
			return;
		}

		this.beech.foreman.send('show-notification', {
			tag: this.prefix + 'low-overflow-agents',
			title: 'Low Overflow Agents',
			body: `There are currently ${numAgents} or fewer agents in Overflow`,
			icon: '',
			requireInteraction: true,
			actions: []
		});
	};

	private handleNotificationClose = (extras: any) => {
		logg.log('notify >> handleNotificationClose');

		if (extras.tag == this.prefix + 'incoming_call') {
			this.incomingCallNotificationVisible = false;
		}
	};

	private handleNotificationClick = (extras: any) => {
		logg.log('notify >> handleNotificationClick');

		// User clicked the notification, but not an action

		if (extras.tag == this.prefix + 'incoming_call') {
			// Leave the notification open, as a chance to hit an action
		}
	};

	private handleNotificationAction = (extras: any) => {
		logg.log('notify >> handleNotificationAction', extras);

		if (extras.tag == this.prefix + 'incoming_call') {
			this.hideIncomingCallNotification();

			if (extras.action == 'accept') {
				this.beech.flow.doRingingAccept();
				return;
			} else if (extras.action == 'reject') {
				this.beech.flow.doRingingReject();
				return;
			}
		}

		throw Error('Unsupported notification action (' + extras.tag + ' / ' + extras.action + ')');
	};
}
